module.exports = __webpack_public_path__ + "img/lebanon.c12ef1d.webp";